import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["validateSchema", "onSubmit"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Form as FinalForm } from 'react-final-form';
import { validator } from './form.helper';
import { jsx as _jsx } from "react/jsx-runtime";
export var Form = function Form(_ref) {
  var validateSchema = _ref.validateSchema,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? function () {
      return undefined;
    } : _ref$onSubmit,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var validate = validateSchema && validator(validateSchema);
  return /*#__PURE__*/_jsx(FinalForm, _objectSpread({
    validate: validate,
    onSubmit: onSubmit
  }, restProps));
};